module.exports = __webpack_public_path__ + "media/images/brand/meta_icons/android-chrome-192x192-20e4989d70064702391f677695256ef6.png";